/* P1.24 : panneau lateral « Tout ».
   Element autonome : il ne depend PAS de menu-drawer, dont la fermeture est liee
   a tous les <button> qu'il contient (ce qui casserait le selecteur de langue). */
class PkPanneau extends HTMLElement {
  connectedCallback() {
    // Plusieurs declencheurs possibles : celui du menu desktop, qui vit dans cet
    // element, et celui du header mobile, qui vit AILLEURS dans la page (la liste
    // du menu horizontal est masquee sous 990 px). On les cherche donc dans tout
    // le document, et on les pilote tous.
    this.boutons = [...document.querySelectorAll('[data-pk-ouvrir]')];
    this.bouton = this.boutons[0];
    if (!this.bouton) return;

    // Le tiroir et le voile doivent vivre dans <body>. Tant qu'ils restent dans le
    // header, ils heritent de son contexte d'empilement (.section-header est en
    // position sticky avec z-index 3) et passent SOUS la barre d'annonce, quel que
    // soit leur propre z-index.
    //
    // ⚠️ Un deplacement sans garde-fou laisse un tiroir orphelin dans <body> chaque
    // fois que la section est rendue a nouveau (editeur de theme, navigation
    // instantanee) : c'est ce qui produisait DEUX panneaux a la seconde ouverture.
    // On purge donc les orphelins avant de deplacer les siens.
    document.querySelectorAll('body > [data-pk-deplace]').forEach((n) => {
      if (!n.__pkHote || !n.__pkHote.isConnected) n.remove();
    });

    this.tiroir = this.querySelector('.pk-panneau__tiroir');
    this.voile = this.querySelector('.pk-panneau__voile');
    if (!this.tiroir || !this.voile) return;

    for (const noeud of [this.voile, this.tiroir]) {
      noeud.setAttribute('data-pk-deplace', '');
      noeud.__pkHote = this;
      document.body.appendChild(noeud);
    }

    this.boutonFermer = this.tiroir.querySelector('[data-pk-fermer]');
    this.ouvert = false;
    // Le bouton a rendre au clavier a la fermeture : celui qui a OUVERT, pas le
    // premier de la liste. Sur mobile et sur desktop ce n'est pas le meme.
    this.declencheur = this.bouton;
    this.surTouche = this.surTouche.bind(this);

    for (const b of this.boutons) {
      b.addEventListener('click', () => {
        this.declencheur = b;
        this.basculer();
      });
    }
    this.voile.addEventListener('click', () => this.fermer());
    if (this.boutonFermer) this.boutonFermer.addEventListener('click', () => this.fermer());
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.surTouche);
    // On emporte ses propres noeuds : sans cela ils survivent dans <body> et
    // s'accumulent a chaque rendu de la section.
    if (this.tiroir) this.tiroir.remove();
    if (this.voile) this.voile.remove();
    document.body.style.overflow = '';
  }

  basculer() {
    if (this.ouvert) this.fermer();
    else this.ouvrir();
  }

  ouvrir() {
    // Tout l'etat tient dans un attribut, et le CSS fait le reste. Aucun `hidden`
    // a poser ni a retirer : c'etait cette bascule, couplee a la fin de transition,
    // qui laissait le tiroir a moitie visible entre deux etats.
    this.setAttribute('data-ouvert', '');
    this.tiroir.setAttribute('data-visible', '');
    this.voile.setAttribute('data-visible', '');
    // L'etat est pose sur CHAQUE bouton : le burger du mobile vit hors de cet
    // element, sa croix ne peut donc pas etre pilotee depuis l'hote.
    for (const b of this.boutons) {
      b.setAttribute('aria-expanded', 'true');
      b.setAttribute('data-ouvert', '');
    }
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.surTouche);
    this.tiroir.focus();
    this.ouvert = true;
  }

  fermer() {
    this.removeAttribute('data-ouvert');
    this.tiroir.removeAttribute('data-visible');
    this.voile.removeAttribute('data-visible');
    for (const b of this.boutons) {
      b.setAttribute('aria-expanded', 'false');
      b.removeAttribute('data-ouvert');
    }
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.surTouche);
    this.ouvert = false;
    if (this.declencheur) this.declencheur.focus();
  }

  surTouche(e) {
    if (e.key === 'Escape') this.fermer();
  }
}

if (!customElements.get('pk-panneau')) {
  customElements.define('pk-panneau', PkPanneau);
}
